import React, { useEffect, useState, useContext } from 'react';
import { Box, Stack, Typography, Container } from '@mui/material';
import PropTypes from 'prop-types';
import AccountDetails from './AccountDetails';
import TermsAndConditions from './TermsAndCondition';
import MaintainUsers from './MaintainUsers';
import MaintainTraders from './MaintainTraders';
import SettingHeader from './SettingHeader';
import { useLocation, useSearchParams } from 'react-router-dom';
import SideNav from './SideNav';
import { getAccountDetails } from '../../api/settings';
import { StoreContext } from '../../components/Store';

import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import TraderIcon from '@mui/icons-material/Business';
import TermsIcon from '@mui/icons-material/Gavel';
import { is360PayStaff } from '../../utils/roles';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`vertical-tabpanel-${index}`} className="wrapper-tabspanel">
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
const tabData = [
  { label: 'Account Settings', id: 'account-settings', icon: <SettingsIcon /> },
  { label: 'Terms and Conditions', id: 'terms-and-conditions', icon: <TermsIcon /> },
  { label: 'Maintain Users', id: 'maintain-users', icon: <PersonIcon /> },
  { label: 'Maintain Traders', id: 'maintain-traders', icon: <TraderIcon /> },
  // { label: "Maintain Transport"},
  // { label: "Maintain Goods"},
];

const TAB_PARAM = 'tab';
const MAX_TAB_INDEX = 3;

export default function CustomerSettings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation();

  // Use state from navigation, or fall back to persisted selection (survives refresh)
  const selectedCompanyId = state?.res?.companyId || sessionStorage.getItem('eoriSelectedCompanyId') || '';
  const store = useContext(StoreContext);

  useEffect(() => {
    if (state?.res?.companyId) {
      sessionStorage.setItem('eoriSelectedCompanyId', state.res.companyId);
    }
  }, [state?.res?.companyId]);

  useEffect(() => {
    if (selectedCompanyId && store.eoriCompany[0] !== selectedCompanyId) {
      store.eoriCompany[1](selectedCompanyId);
    }
  }, [selectedCompanyId, store.eoriCompany]);

  const value = (() => {
    const tabParam = searchParams.get(TAB_PARAM);
    const tabIndex = tabParam !== null ? parseInt(tabParam, 10) : 0;
    return Number.isNaN(tabIndex) || tabIndex < 0 ? 0 : Math.min(tabIndex, MAX_TAB_INDEX);
  })();

  const setValue = (newValue) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (newValue === 0) {
        next.delete(TAB_PARAM);
      } else {
        next.set(TAB_PARAM, String(newValue));
      }
      return next;
    });
  };
  const [headerDetails, setHeaderDetails] = useState('Account Details');

  useEffect(() => {
    const customerType = store.accountDetails[0]?.customerTypeId;
    store.isReadOnly[1](customerType === 40 || is360PayStaff());
  }, [store.accountDetails[0]]);

  const [customerTypeId, setCustomerTypeId] = useState(null);

  useEffect(() => {
    setCustomerTypeId(state?.res?.customerTypeId);
  }, []);

  useEffect(() => {
    if (value === 0) {
      setHeaderDetails('Account Details');
    }
    if (value === 1) {
      setHeaderDetails('Terms and Conditions');
    }
    if (value === 2) {
      setHeaderDetails('Users');
    }
    if (value === 3) {
      setHeaderDetails('Trader Data');
    }
    if (value === 4) {
      setHeaderDetails('Transport Data');
    }
    if (value === 5) {
      setHeaderDetails('Goods Data');
    }
  }, [value]);

  return (
    <Container maxWidth="xl" sx={{ px: 4, mt: 4, mb: 4 }}>
      <Stack direction="row" gap={2} className="stepper-wrapper-tabs">
        <div className="rowWrapper">
          <SettingHeader heading={headerDetails} />
        </div>
        <div className="rowWrapper settings-row">
          <SideNav heading="Settings" tabs={tabData} setValue={setValue} value={value} />

          {/* {tabData.map((tab, index) => ( */}

          <TabPanel index={0} value={value}>
            <AccountDetails companyId={selectedCompanyId} />
          </TabPanel>

          <TabPanel index={1} value={value}>
            <TermsAndConditions companyId={selectedCompanyId} />
          </TabPanel>

          <TabPanel index={2} value={value}>
            <MaintainUsers companyId={selectedCompanyId} customerTypeId={customerTypeId} />
          </TabPanel>

          <TabPanel index={3} value={value}>
            <MaintainTraders companyId={selectedCompanyId} />
          </TabPanel>
        </div>
      </Stack>
    </Container>
  );
}

TabPanel.propTypes = {
  children: PropTypes.func,
  value: PropTypes.string,
  index: PropTypes.string,
};
